<template>
  <v-form ref="form" class="py-6">
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-text-field
          class="required"
          :rules="[$rules.required]"
          v-model="name"
          label="Món ăn"
          placeholder="Tên món ăn"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="pb-0">
        <v-select
          v-model="type"
          :items="dishTypes"
          clear-icon="mdi-close"
          item-text="title"
          item-value="value"
          label="Nhóm món"
          class="required"
          :rules="[$rules.required]"
          outlined
          dense
          clearable
        />
      </v-col>
      <v-col cols="12">
        <v-row class="my-1 mx-0">
          <div class="image-input" :style="{ 'background-image': `url(${imageData})` }" @click="chooseImage">
            <div v-if="$_get(dishData, 'image.url') && !rawImageRemoved" class="placeholder">
              <v-img :src="imgUrl" alt="" contain />
            </div>
            <span v-else-if="!imageData" class="placeholder">
              Tải ảnh món ăn
            </span>
            <input
              class="file-input"
              ref="fileInput"
              type="file"
              accept="image/png, image/jpeg, image/bmp"
              @input="onChange"
            />
          </div>
          <v-btn icon v-if="imageData || $_get(dishData, 'image.url')">
            <v-icon @click="removeImage" color="grey">close</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapState } from 'vuex'

export default {
  components: {},
  props: {
    dishData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('constant', ['dishTypes']),
    imgUrl() {
      if (this.dishData && this.dishData.image) {
        return this.dishData.image.url
      }
      return ''
    }
  },
  data: () => ({
    name: '',
    type: '',
    imageData: null,
    dishImage: '',
    rawImageRemoved: false,
    rules: [value => !value || value.size < 2000000 || 'Ảnh phải cần có dung lượng nhỏ hơn 2 MB!']
  }),
  methods: {
    chooseImage() {
      this.$refs.fileInput.click()
    },
    onChange() {
      if (this.imgUrl) {
        this.rawImageRemoved = true
      }
      const input = this.$refs.fileInput
      const files = input.files
      if (files && files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(files[0])
        this.dishImage = files[0]
      }
    },
    removeImage() {
      if (this.imgUrl) {
        this.rawImageRemoved = true
      }

      this.dishImage = null
      this.imageData = null
    },
    validate() {
      return this.$refs.form.validate()
    },
    resetValidation() {
      return this.$refs.form.resetValidation()
    },
    resetDefault() {
      if (this.dishData) {
        this.name = this.dishData.name
        this.type = this.dishData.type
      } else {
        this.name = ''
        this.type = ''
      }
    },
    getData() {
      return {
        name: this.name,
        type: this.type,
        image: this.dishImage,
        rawImageRemoved: this.rawImageRemoved
      }
    }
  },
  created() {
    this.resetDefault()
  },
  watch: {
    dishData() {
      this.resetDefault()
    }
  }
}
</script>

<style scoped>
.image-input {
  display: block;
  width: 200px;
  height: 200px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.placeholder {
  background: #f0f0f0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: Helvetica;
}
.placeholder:hover {
  background: #e0e0e0;
}

.file-input {
  display: none;
}
</style>
